<script>
    import {onMount} from "svelte";
    import {eventBridge} from "../../stores.js";
    import Expandable from "./Expandable.svelte";

    let { token } = $props();

    let tokenDetails = $state({});

    $effect(() => {
        if (token) {
            tokenDetails = {};
            $eventBridge.dispatchEvent('cs:getCertDataForSecurityToken', {
                tokenId: token.fingerprint
            });
        }
    });

    onMount(() => {
        const handleCertData = (event) => {
            tokenDetails = JSON.parse(event.payload);
        };

        $eventBridge.addEventListener('cs:CertDataForSecurityToken', handleCertData);

        return () => {
            $eventBridge.removeEventListener('cs:CertDataForSecurityToken', handleCertData);
        };
    });
</script>

<div class="certificateList">
    {#each Object.values(tokenDetails.certificateList || {}) as certificate, i}
        <div class="certBasicInfo">
            <table>
                <thead></thead>
                <tbody>
                <tr>
                    <td class="keyTitle">Inhaber:</td><td>{certificate.subject}</td>
                </tr>
                <tr>
                    <td class="keyTitle">Aussteller:</td><td>{certificate.issuer}</td>
                </tr>
                <tr>
                    <td class="keyTitle">Gültig bis:</td><td>{certificate.expirationDate}</td>
                </tr>
                {#if certificate.signatureLevel !== 'UNKNOWN'}
                    <tr>
                        <td class="keyTitle">Signaturlevel:</td><td>{certificate.signatureLevel}</td>
                    </tr>
                {/if}
                </tbody>
            </table>
        </div>
        <Expandable headerText={'Details'}>
            <div>
                <table>
                    <thead></thead>
                    <tbody>
                    {#each certificate.details as keyValue, j}
                        {@const keyValueEntry = keyValue.split('=')}
                        <tr>
                            {#if keyValueEntry[0] === 'null'}
                                <td></td><td>{keyValueEntry[1]}</td>
                            {:else if keyValueEntry[1] === 'null'}
                                <td colspan="2" class="keyTitle keySection">{keyValueEntry[0]}</td>
                            {:else}
                                <td class="value">{keyValueEntry[0]}</td><td>{keyValueEntry[1]}</td>
                            {/if}
                        </tr>
                    {/each}
                    </tbody>
                </table>
            </div>
        </Expandable>
    {/each}
</div>

<style>
    .certBasicInfo {
        margin-bottom: 1em;
        margin-top: 1em;
    }

    .keyTitle {
        font-weight: bold;
        padding-right: 1em;
    }

    .keySection {
        padding-top: 1em;
    }

    .value {
        vertical-align:top;
        padding-right:1em;
    }
</style>
